<template>
  <v-btn
    @click="confirmDelete('1', myKey, 'General', item)"
    variant="flat"
    class="mr-3 refresh-button"
    style="height: 56px !important"
    :color="myKey in deluge?.pinned_svars?.['1']?.['General'] ? 'primary' : ''">
    <v-icon style="height: 33px; opacity: 0.7">mdi-pin</v-icon>
  </v-btn>
</template>

<script setup>
import { deluge, deluge_sock } from '@/stores/deluge.js';
const props = defineProps(['myKey', 'item']);

function confirmDelete(frame, svar, preset, val) {
  let pinned_items = JSON.parse(JSON.stringify(deluge.pinned_svars));
  if (svar in pinned_items[frame][preset]) {
    if (confirm('Are you sure you want to delete this variable?')) {
      togglePinKey(frame, svar, preset, val);
    }
  } else {
    togglePinKey(frame, svar, preset, val);
  }
}

function togglePinKey(frame, svar, preset, val) {
  let pinned_items = JSON.parse(JSON.stringify(deluge.pinned_svars));
  if (svar in pinned_items[frame][preset]) {
    delete pinned_items[frame][preset][svar];
  } else {
    pinned_items[frame][preset][svar] = { auto: false, value: val };
  }
  if (window.self !== window.top) {
    parent.postMessage(
      {
        deluge_cmd: {
          cmd: 'STORE',
          key: 'pinned_svars',
          publish: true,
          persist: true,
          keys: [],
          val: JSON.parse(JSON.stringify(pinned_items)),
        },
      },
      '*'
    );
  } else {
    deluge_sock.value.send(
      new Blob([
        JSON.stringify({
          cmd: 'STORE',
          key: 'pinned_svars',
          publish: true,
          persist: true,
          keys: [],
          val: pinned_items,
        }),
      ])
    );
  }
}
</script>
